import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPeriodCapacityData,
  GetPeriodCapacityDataRequest,
  GetPeriodCapacityDataResponse,
} from "./periodCapacityData.api";

export const GetPeriodCapacityDataThunk = createAsyncThunk(
  "periodCapacityDate/GetPeriodCapacityData",
  async (
    request: GetPeriodCapacityDataRequest,
    { rejectWithValue, dispatch }
  ) => {
    const { response, error } = await getPeriodCapacityData(request);
    if (error) {
      return rejectWithValue(error);
    }
    return response;
  }
);
